import { useEffect, useState } from 'react'
import API from 'api'

export default function getUserLocationByCoord(coords, currentTitle = '') {
  const [locationInfo, setLocationInfo] = useState({ title: currentTitle })

  useEffect(() => {
    const params = coords
      ? {
        latitude: coords.latitude,
        longitude: coords.longitude,
      }
      : null

    API('/api/adventure/v1/destinations/locator/')
      .get(params)
      .then((data) => setLocationInfo(data))
  }, [])

  return locationInfo
}
